import { useContext, useEffect } from 'react'

import { useLogCashWebCdfEvent } from '@cash-web/shared-feature-analytics'
import { ExperimentActivateView } from '@squareup/customer-data-events-web'

import { type Experiments } from '../Experiments'
import { DEFAULT_EXPERIMENTS, ExperimentsContext } from '../ExperimentsContext'

export const useExperiment = <T extends keyof Experiments>(
  experimentKey: T,
  skipAssignmentEvent = false
): Partial<Experiments>[T] | undefined => {
  const { experiments, emittedAssignmentEvent } = useContext(ExperimentsContext)
  if (process.env['NODE_ENV'] === 'development' && experiments === DEFAULT_EXPERIMENTS) {
    throw new Error('useExperiment must be used within ExperimentsProvider.')
  }

  const logCdfEvent = useLogCashWebCdfEvent()
  const selectedExperiment = experiments?.[experimentKey]
  const experimentValue = selectedExperiment?.variant_value

  useEffect(() => {
    if (
      skipAssignmentEvent ||
      !emittedAssignmentEvent ||
      (emittedAssignmentEvent?.current[experimentKey] &&
        emittedAssignmentEvent.current[experimentKey] === experimentValue)
    ) {
      return
    }

    if (experimentValue) {
      emittedAssignmentEvent.current[experimentKey] = experimentValue
      void logCdfEvent(
        ExperimentActivateView({
          experimentId: experimentKey,
          variationId: experimentValue,
          experimentSource: 'AMPLITUDE',
        })
      )
    }
  })

  return selectedExperiment
}
